import React from "react";
import { Apple, BoxArrowUpRight } from "react-bootstrap-icons";
import "./appStoreGuidance.css";

const APPLE_SUBSCRIPTIONS_URL = "https://apps.apple.com/account/subscriptions";

/**
 * Shared App Store guidance block.
 *
 * Rendered inside ManageSubscriptionModal (subscription management) and
 * UpgradePlanModal (checkout gate) so the message stays identical wherever
 * an App-Store-billed user lands.
 */
const AppStoreGuidance = () => (
  <div className="app-store-guidance">
    <div className="app-store-guidance-icon">
      <Apple />
    </div>
    <ol className="app-store-guidance-steps">
      <li>Open Settings on your Apple device.</li>
      <li>Tap your name.</li>
      <li>Tap Subscriptions.</li>
    </ol>
    <a
      className="app-store-guidance-link"
      href={APPLE_SUBSCRIPTIONS_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Or manage it in your browser{" "}
      <span className="visually-hidden">(opens in a new tab)</span>
      <BoxArrowUpRight aria-hidden="true" />
    </a>
  </div>
);

export default AppStoreGuidance;
